import React from 'react'
import {CheckOutlined} from '@ant-design/icons'

import BButton from 'components/Form/Fields/BButton'
import BInput from 'components/Form/Fields/BInput'
import BInputNumber from 'components/Form/Fields/BInputNumber'
import FormHandler from 'components/Form/FormHandler'
import BSelect from 'components/Form/Fields/BSelect'
import PaymentCard from 'components/Payment/PaymentCard'
import BSwitch from 'components/Form/Fields/BSwitch'


const Components = () => (
  <div style={{margin: '16px'}}>
    Typography
    <h1>h1. Headline</h1>
    <h2>h2. Headline</h2>
    <h3>h3. Headline</h3>
    <h4>h4. Headline</h4>
    <p>Plain text</p>
    <label>Label</label>

    <h1>Buttons</h1>
    <BButton style={{margin: '8px'}}><CheckOutlined/> Primary</BButton>
    <BButton style={{margin: '8px'}}>Primary</BButton>
    <BButton yellow style={{margin: '8px'}}>Yellow</BButton>
    <BButton yellow bordered style={{margin: '8px'}}>Yellow border</BButton>
    <BButton style={{margin: '8px'}}><CheckOutlined/> Primary long text in the button yayyyy</BButton>
    <BButton disabled style={{margin: '8px'}}>Disabled</BButton>

    Input

    <FormHandler>
      <BInput label='Test label' placeholder='Test' fieldName='test2'/>

      <BInputNumber label='Number'/>

      <div><BSwitch/></div>

    </FormHandler>

    <BSelect defaultValue='option42'>
      {[...Array(100).keys()].map(e => <option value={'option' + e}>Option {e}</option>)}
    </BSelect>

    <h1>Placeholder</h1>
    <h1>Placeholder</h1>
    <h1>Placeholder</h1>

    <div style={{background: '#e8f1f1'}}>
      <FormHandler>
        <BInput white style={{margin: '8px'}} fieldName='test'><CheckOutlined/></BInput>

        <BInput white label='Test label' placeholder='Test' style={{margin: '8px'}} fieldName='test'/>
      </FormHandler>
    </div>

    <PaymentCard/>

  </div>
)

export default Components
